import React, { useEffect } from "react";
import {
  FaDraftingCompass,
  FaHardHat,
  FaBalanceScale,
  FaFileAlt,
  FaCheckCircle,
  FaTools,
  FaHome,
  FaClipboardCheck,
} from "react-icons/fa";
import { MdOutlineChair } from "react-icons/md";
import { GiSteelClaws } from "react-icons/gi";
import { Link } from "react-router-dom";
import "./About.css";

const services = [
  {
    key: "arch",
    name: "Architectural Design",
    icon: <FaDraftingCompass className="uma-icon" />,
    desc: "Thoughtful planning and creative design for residential and commercial spaces.",
  },
  {
    key: "inter",
    name: "Interior Design",
    icon: <MdOutlineChair className="uma-icon" />,
    desc: "Modern, functional interiors that reflect your lifestyle and personality.",
  },
  {
    key: "const",
    name: "Construction",
    icon: <FaHardHat className="uma-icon" />,
    desc: "Reliable and efficient execution with top-tier materials and craftsmanship.",
  },
  {
    key: "val",
    name: "Valuation",
    icon: <FaBalanceScale className="uma-icon" />,
    desc: "Accurate property valuation backed by professional expertise.",
  },
  {
    key: "doc",
    name: "Document Work",
    icon: <FaFileAlt className="uma-icon" />,
    desc: "Hassle-free handling of all building and property documentation.",
  },
  {
    key: "str",
    name: "Structure Design",
    icon: <GiSteelClaws className="uma-icon" />,
    desc: "Safe and sustainable structural engineering for long-lasting results.",
  },
  {
    key: "qc",
    name: "Quality Control",
    icon: <FaCheckCircle className="uma-icon" />,
    desc: "Rigorous monitoring to ensure every project meets the highest standards.",
  },
  {
    key: "reno",
    name: "Renovation",
    icon: <FaTools className="uma-icon" />,
    desc: "Transforming old spaces into modern, elegant, and functional environments.",
  },
  {
    key: "deal",
    name: "Property Dealing",
    icon: <FaHome className="uma-icon" />,
    desc: "Transparent and professional assistance in buying or selling properties.",
  },
  {
    key: "perm",
    name: "Building Permission",
    icon: <FaClipboardCheck className="uma-icon" />,
    desc: "End-to-end guidance through government approvals and compliance.",
  },
];

const About = () => {
  useEffect(() => {
    const elems = Array.from(document.querySelectorAll('.uma-revealable'));
    if (!('IntersectionObserver' in window)) {
      elems.forEach((el) => el.classList.add('uma-in-view'));
      return;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('uma-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    elems.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="uma-about-section">
      <div className="uma-about-container container">
        <div className="uma-about-main">
          <div className="uma-about-copy uma-revealable">
            <h1 className="uma-brand">UMA Design & Construction</h1>
            <p className="uma-subtitle">Building Dreams — Creating Futures</p>

            <p className="uma-intro">
              At UMA Design and Constructions, we bring your vision to life — from
              concept to creation. We combine expertise, innovation, and
              commitment to deliver end-to-end solutions for every stage of your
              project. Whether it’s designing your dream home, constructing a
              modern commercial space, or managing property documentation — we
              ensure precision, quality, and trust in everything we do.
            </p>

            <h3 className="uma-services-heading">Our Services Include</h3>
          </div>

          <div className="uma-services-rail">
            {services.map((s, i) => (
              <div key={s.key} className="uma-service-card uma-revealable" style={{ ['--i']: i }}>
                <div className="uma-service-icon">{s.icon}</div>
                <div className="uma-service-body">
                  <div className="uma-service-name">{s.name}</div>
                  <div className="uma-service-desc">{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="uma-promise uma-revealable">
          <h3>Our Promise</h3>
          <p>
            We don’t just build structures — we build trust, value, and
            relationships that stand strong for years to come.
          </p>
          <Link to="/contact" className="uma-cta">Contact Us for a Quote</Link>
        </div>
      </div>
    </div>
  );
};

export default About;
